module.exports = __webpack_public_path__ + "img/fangxin.7bce9da4.png";